export const GET_FORM_REQUEST = 'GET_FORM_REQUEST';
export const GET_FORM_SUCCESS = 'GET_FORM_SUCCESS';
export const GET_FORM_ERROR = 'GET_FORM_ERROR';
export const SET_OPTIONS_BY_FIELDS = 'SET_OPTIONS_BY_FIELDS';



// WEBPACK FOOTER //
// ./src/store/formStructure/formStructureActionTypes.js